import { Title } from '@angular/platform-browser';
import {
  trigger,
  state,
  style,
  transition,
  animate,
  keyframes,
} from '@angular/animations';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { lastValueFrom, map, throwError } from 'rxjs';
import { PageItem } from 'src/app/models/portal';
import { ApiService } from 'src/app/shared/services';
import { UserDashboardService } from 'src/app/shared/services/user-dashboard.service';

import { MailServiceStatus } from '../../../portal.model';
import {
  SharedPortalViewService,
  PortalViewPageStatusEnum,
} from '../../shared-portal-view.service';

export enum PortalNavigatorEnum {
  site_settings,
  pages,
  site_apperances,
}

export enum PagesFilterNavigatorEnum {
  all,
  published,
  draft,
}

@Component({
  selector: 'app-portal-marketing-overview',
  templateUrl: './portal-marketing-overview.component.html',
  styleUrls: ['./portal-marketing-overview.component.css'],
  animations: [
    trigger('divStateDraft', [
      state(
        'in',
        style({ backgroundColor: 'red', transform: 'translateX(0)' }),
      ),

      transition('void => *', [
        animate(
          1000,
          keyframes([
            style({ opacity: 0, transform: 'translateY(-100%)' }),
            style({ opacity: 1, transform: 'translateY(15px)' }),
            style({ opacity: 1, transform: 'translateY(0)' }),
          ]),
        ),
      ]),
      transition('* => void', [
        animate(
          500,
          keyframes([
            style({ opacity: 1, transform: 'translateY(0)' }),
            style({ opacity: 1, transform: 'translateY(-15px)' }),
            style({ opacity: 0, transform: 'translateY(100%)' }),
          ]),
        ),
      ]),
    ]),
    trigger('divState', [
      state(
        'in',
        style({ backgroundColor: 'red', transform: 'translateX(0)' }),
      ),

      transition('void => *', [
        animate(
          1000,
          keyframes([
            style({ opacity: 0, transform: 'translateY(-100%)' }),
            style({ opacity: 1, transform: 'translateY(15px)' }),
            style({ opacity: 1, transform: 'translateY(0)' }),
          ]),
        ),
      ]),
      transition('* => void', [
        animate(
          0,
          keyframes([
            style({ opacity: 1, transform: 'translateY(0)' }),
            style({ opacity: 1, transform: 'translateY(-15px)' }),
            style({ opacity: 0, transform: 'translateY(100%)' }),
          ]),
        ),
      ]),
    ]),
    trigger('inOutAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('1s ease-out', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('0s ease-in', style({ opacity: 0 })),
      ]),
    ]),
  ],
})
export class PortalMarketingOverviewComponent implements OnInit {
  mailServiceStatus: MailServiceStatus = MailServiceStatus.not_configured;
  userMailOptionsSize: number;
  userMailOptions: any;

  constructor(
    private renderer: Renderer2,
    private route: Router,
    private aroute: ActivatedRoute,
    private api: ApiService,
    private userDashboardService: UserDashboardService,
    public sharedPortalViewService: SharedPortalViewService,
    private title: Title,
  ) {
    this.sharedPortalViewService.setPageStatus(
      PortalViewPageStatusEnum.marketing_overview,
    );
    this.handleError = this.handleError.bind(this);
  }

  async ngOnInit() {
    this.title.setTitle(
      this.sharedPortalViewService.currentWebsite.website.label +
        ' > ' +
        'Marketing Overview',
    );
  }

  goToSubscribers() {
    this.route.navigate([
      'dashboard',
      'portal',
      'view',
      this.sharedPortalViewService.currentWebsite.id,
      'marketing',
      'subscribers',
    ]);
  }

  goToSenderMailConfiguration() {
    this.route.navigate([
      'dashboard',
      'portal',
      'view',
      this.sharedPortalViewService.currentWebsite.id,
      'marketing',
      'sending-mail',
    ]);
  }

  private handleError(error: HttpErrorResponse) {
    const msg = 'Something went wrong in portal service.';
    // return an observable with a user friendly message
    return throwError(error.message || msg);
  }
}
